export default __webpack_public_path__ + "static/media/happyAstronaut.17d4ca22.svg";